import React from 'react';
import { PropTypes } from 'react';
import { ItemTypes } from '../commonJS/constants';
import getSort from '../commonJS/getSort';
import { DropTarget } from 'react-dnd';
import { DragSource } from 'react-dnd';

import MaskLink from './MaskLink';
import RemoveIcon from './RemoveIcon';

// spec, collet for drag source
const previewSource = {
  beginDrag(props) {
    return { fileName: props.fileName };
  },
  canDrag(props, monitor) {
    let productId;
    if (props.containerThis.props.params) productId = props.containerThis.props.params.productId;
    return props.containerThis.state.onEdit || !productId || props.containerThis.state.onCopy;
  }
}

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    // customerize the drag preview
    // connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
}

// spec, collet for drop target
const previewTarget = {
  // drop(props, monitor) {
  //   const srcFileName = monitor.getItem().fileName,
  //         srcInd = getSort(props.fileSort, srcFileName),
  //         tarInd = getSort(props.fileSort, props.fileName);


  //   props.fileSort.splice(srcInd, 1);
  //   props.fileSort.splice(tarInd, 0, srcFileName);
  //   // 即使state值相同仍會觸發render，這值得研究觸發機制提升效能
  //   props.parentStateHandler({states: 'forceUpdate', values: true});
  // }

  hover(props, monitor, component) {
    const srcFileName = monitor.getItem().fileName,
      srcInd = getSort(props.fileSort, srcFileName),
      tarInd = getSort(props.fileSort, props.fileName);

    // Don't replace items with themselves
    if (srcInd === tarInd) {
      return;
    }

    props.fileSort.splice(srcInd, 1);
    props.fileSort.splice(tarInd, 0, srcFileName);
    // 即使state值相同仍會觸發render，這值得研究觸發機制提升效能
    props.parentStateHandler({ states: ['forceUpdate', 'sholudUpdateFilesSort'], newValues: [true, true] });
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

const PreviewImg = props => {
  let onDragging;
  // let onOver;

  if (props.enableDnd) {
    const { isDragging/*, isOver*/ } = props;
    onDragging = isDragging;
    // onOver = isOver;
  }

  const temp = <figure style={{ opacity: onDragging ? 0 : 1 }}>
    {
      props.showName ?
        <div>{props.fileName}</div>
        :
        <img src={props.src} alt="thumbnail" />
    }

    {/*<figcaption>{item.name || item.file_name}</figcaption>*/}

    <MaskLink href={props.href} />
    <RemoveIcon onFileDelete={e => { e.stopPropagation(); props.ownerThis.onFileDelete(props.fileType, props.fileName); }} />
  </figure>;

  if (props.enableDnd) {
    const { connectDragSource, connectDropTarget } = props;
    return connectDragSource(connectDropTarget(temp));
  } else {
    return (temp);
  }
};

PreviewImg.propTypes = {
  isDragging: PropTypes.bool.isRequired,
};

export const PreviewImgWithDnd = DragSource(ItemTypes.img, previewSource, collectSource)(DropTarget(ItemTypes.img, previewTarget, collectTarget)(PreviewImg));
export const PreviewPDFWithDnd = DragSource(ItemTypes.pdf, previewSource, collectSource)(DropTarget(ItemTypes.pdf, previewTarget, collectTarget)(PreviewImg));
export const PreviewVideoWithDnd = DragSource(ItemTypes.video, previewSource, collectSource)(DropTarget(ItemTypes.video, previewTarget, collectTarget)(PreviewImg));


// WEBPACK FOOTER //
// ./src/commonComponents/FilePreviewPs.jsx